import * as React from 'react';
import { createPortal } from 'react-dom';
import useIsRtl from 'src/hooks/useIsRtl';

//Todo: document is not defined 오류 해결
const portalElement = typeof window === 'object' && document.createElement('div');
interface Props {
  children?: React.ReactNode;
}
const Portal = ({
  children
}: Props) => {
  const isRtl = useIsRtl();
  if (!portalElement) return null;
  portalElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  document.getElementById('modal-root')?.appendChild(portalElement);
  return createPortal(children, portalElement);
};
export default Portal;